<script lang="ts">
	import type { CustomBlockComponentProps } from '@portabletext/svelte';
	import YouTube from '@samsveltecomponents/core/YouTube.svelte';

	interface Props {
		portableText: CustomBlockComponentProps<{
			id: string;
			autoplay?: boolean;
			title?: string;
		}>;
	}

	let { portableText }: Props = $props();

	const { id, autoplay, title } = portableText.value;
</script>

<YouTube {id} {autoplay} {title} />
